<template>
    <div v-loading.fullscreen.lock="state.fullLoading" element-loading-background="rgba(0, 0, 0, 0.3)">
        <el-card class="box-card">
            <el-page-header content="订单记录" :icon="null" title="订单管理">
                <template #extra>
                    <el-button type="primary" @click="searchFun(1)">查询</el-button>
                    <el-button @click="searchFun(2)">重置</el-button>
                </template>
                <el-form :model="search" label-width="80px" class="demo-ruleForm">
                    <el-row :gutter="20">
                        <!-- <el-col :span="8">
                            <el-form-item label="用户ID:" prop="userId">
                                <el-input v-model="search.userId" placeholder="请输入用户ID" @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="8">
                            <el-form-item label="手机号:" prop="userPhone">
                                <el-input v-model="search.userPhone" type="number" placeholder="请输入手机号"
                                    @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="支付订单:" prop="tradeNo">
                                <el-input v-model="search.tradeNo" placeholder="请输入支付订单号" @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="订单状态:" prop="orderStatus">
                                <el-select v-model="search.orderStatus" class="m-2" clearable placeholder="请选择退款状态"
                                    style="width: 100%" @change="searchFun(1)">
                                    <el-option v-for="item in state.options" :key="item.value" :label="item.label"
                                        :value="item.value" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="车架号:" prop="vin">
                                <el-input v-model="search.vin" placeholder="请输入车架号" @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="支付金额:" prop="paymentAmount">
                                <el-input v-model="search.paymentAmount" type="number" @blur="amtBlur"
                                    placeholder="请输入支付金额" @keyup.enter="searchFun(1)">
                                    <template #suffix>
                                        <span>元</span>
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="支付时间:" prop="daterange">
                                <el-date-picker v-model="search.daterange" type="datetimerange" range-separator="-"
                                    start-placeholder="开始时间" end-placeholder="结束时间" format="YYYY-MM-DD HH:mm:ss"
                                    value-format="YYYY-MM-DD HH:mm:ss" date-format="YYYY-MM-DD" time-format="HH:mm:ss"
                                    style="width: 100%" @change="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-page-header>
            <el-table :data="tableData" border style="width: 100%" height="calc(100vh - 347px)" row-key="id"
                v-loading="state.tableLoading">
                <el-table-column prop="type" label="评估类型" min-width="100px" />
                <el-table-column prop="vin" label="车架号" min-width="190px" />
                <!-- <el-table-column prop="userId" label="用户ID" min-width="200px" /> -->
                <el-table-column prop="userPhone" label="手机号码" min-width="120px" />
                <el-table-column prop="paymentAmount" label="支付金额（元）" min-width="150px">
                    <template #default="scope">
                        <el-text class="mx-1" type="primary">
                            {{ formatCurrency(scope.row.paymentAmount / 100, 2, '.', ',') }}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column prop="rateAmt" label="折扣金额（元）" min-width="150px">
                    <template #default="scope">
                        <el-text class="mx-1" type="primary">
                            {{ formatCurrency(scope.row.rateAmt / 100, 2, '.', ',') }}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column prop="commissionDiscount" label="减免佣金（元）" min-width="150px">
                    <template #default="scope">
                        <el-text class="mx-1" type="primary">
                            {{ formatCurrency(scope.row.commissionDiscount / 100, 2, '.', ',') }}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column prop="balanceDiscount" label="减免余额（元）" min-width="150px">
                    <template #default="scope">
                        <el-text class="mx-1" type="primary">
                            {{ formatCurrency(scope.row.balanceDiscount / 100, 2, '.', ',') }}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column prop="orderStatus" label="订单状态" min-width="130px" />
                <el-table-column prop="createTime" label="支付时间" min-width="180px" />
                <el-table-column prop="createType" label="创建方式" min-width="130px" />
                <el-table-column prop="tradeNo" label="支付订单" min-width="300px" />
                <el-table-column prop="outTradeNo" label="外部支付单号" min-width="280px" />
                <!-- <el-table-column prop="transactionId" label="支付平台生成的交易ID" min-width="280px" /> -->
            </el-table>
            <div class="pagination-box">
                <el-pagination background layout="total,sizes,prev, pager, next"
                    v-model:current-page="pagination.current" v-model:page-size="pagination.size"
                    :total="pagination.total" :page-sizes="pagination.sizes" :page-size="pagination.size"
                    prev-text="上一页" next-text="下一页" @current-change="intTableData" @size-change="intTableData" />
                <div style="clear: both;"></div>
            </div>
        </el-card>
    </div>
</template>
<script setup>
import { reactive, ref, onMounted } from "vue";
import { getConsumptionListFun } from "@/api/consumption"
import { formatCurrency } from "@/util/formValidator";

const search = reactive({
    userId: "",
    userPhone: "",
    tradeNo: "",
    paymentAmount: "",
    orderStatus: "",
    daterange: '',
    vin: '',
})
const state = reactive({
    fullLoading: false,
    tableLoading: false,
    options: [
        { label: "已支付", value: '已支付' },
        { label: "等待支付", value: '等待支付' },
        { label: "已退款", value: '已退款' },
    ],
})
const tableData = ref([]);
const pagination = reactive({
    current: 1,
    size: 20,
    total: 0,
    sizes: [20, 50, 100]
});
// 查询 1查询 2重置
const searchFun = (type) => {
    if (type == 2) {
        search.userId = '';
        search.userPhone = '';
        search.tradeNo = '';
        search.paymentAmount = '';
        search.daterange = '';
        search.vin = '';
        search.orderStatus = '';
    }
    pagination.current = 1;
    intTableData();
}
// 获取表格数据
const intTableData = async () => {
    state.tableLoading = true;
    const params = {
        keys: ['current', 'size'],
        formValue: {
            current: pagination.current,
            size: pagination.size,
        }
    }

    for (let key in search) {
        if (search[key]) {
            if (key == 'daterange') {
                params.formValue['startTime'] = search[key][0];
                params.formValue['endTime'] = search[key][1];
                params.keys.push('startTime');
                params.keys.push('endTime');
            } else if (key == 'paymentAmount') {
                params.formValue['paymentAmount'] = Number(search[key]) * 100;
                params.keys.push('paymentAmount');
            } else {
                params.keys.push(key);
                params.formValue[key] = search[key];
            }
        }
    }
    getConsumptionListFun(params).then((res) => {
        tableData.value = res.data.records;
        pagination.total = res.data.total;
    }).finally(() => {
        state.tableLoading = false;
    });
}
// 金额框失去焦点事件
const amtBlur = (e) => {
    const value = e.target.value;
    if (value) {
        search.paymentAmount = Number(Number(value).toFixed(2));
    }
}
onMounted(() => {
    intTableData();
});
</script>
<style lang="scss" scoped>
.demo-ruleForm {
    margin-top: 15px;
}

.pagination-box {
    text-align: right;
}

.el-pagination {
    margin-top: 15px;
    float: right;
}


.dialog-content {
    height: 65vh;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
}

::v-deep input[type='number'] {
    -moz-appearance: textfield !important;
}
</style>